const products = document.querySelectorAll('.c-product-card.has-change-logic');

function forEachHandler(value, array) {
  array.forEach(item => {
    item.dataset.value == value ?
      item.classList.add('is-active') :
      item.classList.remove('is-active');
  })
}

function changeImageHandler(value, images, swatches) {
  forEachHandler(value, images);
  forEachHandler(value, swatches);
}

products.forEach(product => {
  const swatches = product.querySelectorAll('.c-product-change'),
    images = product.querySelectorAll('.c-product-images');

  swatches?.forEach(swatch => {
    swatch.addEventListener('click', () => changeImageHandler(swatch.dataset.value, images, swatches));
  })
});